import type { GridStackWidget } from 'gridstack';
import type { SensorRun } from './dashboardTypes';

export function deriveSessionRunIds(allData: SensorRun[] | undefined): number[] | null {
  if (!allData?.length) return null;
  return allData.map((datum) => datum.runId);
}

/** Resolves the historic session to display, falling back to the latest saved run. */
export function resolveHistoricRun(allData: SensorRun[], runDate: number | null): SensorRun | undefined {
  if (!allData.length) return undefined;
  const selected = allData.find((run) => run.runId === Number(runDate));
  return selected ?? allData[allData.length - 1];
}

/** Returns the dashboard layout captured with a historic session. */
export function resolveHistoricLayout(allData: SensorRun[], runDate: number | null): GridStackWidget[] {
  return resolveHistoricRun(allData, runDate)?.dashboardLayout ?? [];
}

export function detectProgramStopTransition(prevIsProgramRunning: boolean, isProgramRunning: boolean): boolean {
  return prevIsProgramRunning && !isProgramRunning;
}

/** Wait for Dexie/useLiveQuery to surface the just-finished run before hydrating historic charts. */
export function shouldDeferHistoricLoad(options: { skipNextHistoricalLoad: boolean; allData: SensorRun[] | undefined }): boolean {
  if (!options.skipNextHistoricalLoad) return false;
  return !options.allData?.length;
}

/** Avoid wiping charts while waiting for Dexie to propagate a just-finished run. */
export function shouldClearHistoricGraphsToPlaceholder(options: { allData: SensorRun[] | undefined; deferHistoricLoad: boolean }): boolean {
  if (options.deferHistoricLoad) return false;
  return !options.allData?.length;
}

export function shouldAutoSelectLatestRunDate(options: { allData: SensorRun[] | undefined; previousRunCount: number }): number | null {
  if (!options.allData?.length) return null;
  if (options.allData.length <= options.previousRunCount) return null;
  return options.allData[options.allData.length - 1]?.runId ?? null;
}
